import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoadingController, Platform } from '@ionic/angular';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { eMfaStatuses, UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CustomerModel } from 'src/app/models/customer-model';

declare var window:any

declare global {
  interface Window { 
    idnow: {
      startIdNowSdk: (
        token: String,
        successFn: (success:any) => void,
        errorFn: (error:any) => void
      ) => void,
      setCompanyId: (
        company: String,
        successFn?: (success:any) => void,
        errorFn?: (error:any) => void
      ) => void,
      isTestEnvironment: (
        isTest: boolean,
        successFn?: (success:any) => void,
        errorFn?: (error:any) => void
      ) => void
    }
  }
}

@Component({
  selector: 'app-id-now',
  templateUrl: './id-now.component.html',
  styleUrls: ['./id-now.component.scss'],
})
export class IdNowComponent implements OnInit {

  @Input() idScanURLFromReconfirmation: string;
  public expectIdIframeUrl: SafeResourceUrl;
  public idScanInProgress: boolean = false;
  public idScanFailed: boolean = null;
  public idScanFraud: boolean = null;
  public existingId: boolean = null;
  public userScanVerifySuccess: boolean = null;
  public registrationSuccessful: boolean = false;
  public idScanCallBack: boolean = false;
  private loading;
  private message;
  public feautureCustomerSupportURL: string;
  
  constructor(
    private sanitizer: DomSanitizer,
    public platform: Platform,
    public eventService: EventsService,
    public configService: ConfigService,
    public authenticationService: AuthenticationService,
    public logoutService: LogoutService,
    public appLinksService: AppLinksService,
    public loadingController: LoadingController,
    private userSessionService: UserSessionService,
    private navigator: Navigator,
    
  ) {
    this.expectIdIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
    if( this.platform.is( 'capacitor')) {
     this.eventService.subscribe('event:SDK', async (data) => {
      if(data=="SDKFINISHED"){
        this.message = await this.loadingController.create({
          message: 'Processing....'
        });
        this.message.present();
      }
    });}
    this.eventService.subscribe('event:IDNow:CallBack', (data) => {
      this.idScanCallBack = true;
          setTimeout(() => {
        this.IDNowCallBack(data);
      }, 3000);
    });
    this.eventService.subscribe('event:ReKyc:AnnualReconfirmation', () => {
      setTimeout(() => {
        this.idScanCallBack = true;
        if(this.idScanURLFromReconfirmation){
          this.IDNowCallBack('RE_KYC_ANNUAL_RECONFIRMATION');
        }
      }, 2000);
    })
   }

  ngOnInit() {
    console.log('ngOnInit---', !this.idScanCallBack);
    this.feautureCustomerSupportURL = this.configService.getConfig().FEATURE_CUSTOMER_SUPPORT_URL || '';
    if (this.idScanURLFromReconfirmation) {
      console.log('user came from Reconfirmation');
      if (this.platform.is('capacitor')) {
        return this.getIdNowResultCapacitor();
      }
      this.expectIdIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.idScanURLFromReconfirmation);
    } else {
      if (!this.idScanCallBack) {
        this.getIdNowResult();
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdNowPage');
   this.loadingControlloer();
    this.eventService.publish("event:lobby:hide");
  }

  async loadingControlloer() {
    if( !this.loading) {
      this.loading = await this.loadingController.create({
        message: 'Loading....'
      });
  }
  }

    //To get the IDNOW Iframe URL which can be done through getIDNowResult
    public getIdNowUrl = () => {
      this.authenticationService.getIDNowUrl().subscribe(
        (response: any) => {
          if (response && !!response.result) {
            console.log('ID Now URL ::', response.payload.id_scan_url);
            this.expectIdIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.payload.id_scan_url);
          }
        },
        (error: any) => {
          console.log('getIdNowUrl: error');
          console.log(error);
        });
    }
   
    public getIdNowResult = () => {
      if( this.platform.is( 'capacitor')) {
        return this.getIdNowResultCapacitor();
      } else {
        return this.getIdNowResultWeb();
      }
    }
  
    public getIdNowResultWeb = () => {
      this.authenticationService.getIDNowResult().subscribe(
        (response: any) => {
          if (response && !!response.result) {
            console.log('ID Now Result ::', response.payload);
            this.showLoading();
            // in case loader is stuck
            setTimeout(() => {
              if (this.loading) {
                this.loading.dismiss();
              }
            }, 3000);
            if (response.payload.is_verified === "true") {
              this.registrationSuccessful = true;
              this.userScanVerifySuccess = true;
              this.removeIframe();
              this.doMFA();
            } else if (response.payload.id_scan_result === "inprogress") {
              this.idScanInProgress = true;
              console.log('ID Now URL ::', response.payload.id_scan_url);
              if(response.payload.id_scan_url){
                this.expectIdIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.payload.id_scan_url);
              }
            } else if (response.payload.id_scan_result === "pending") {
              this.userScanVerifySuccess = false;
              this.idScanInProgress = false;
              this.removeIframe();
            } else if (response.payload.id_scan_result === "timeout") {
              this.userScanVerifySuccess = false;
              this.idScanInProgress = false;
              this.removeIframe();
            } else if (response.payload.id_scan_result === "fail") {
              this.userScanVerifySuccess = false;
              this.idScanFailed = true;
              this.removeIframe()
            } else if (response.payload.id_scan_result === "FRAUD_SUSPICION_PENDING") {
              this.userScanVerifySuccess = false;
              this.idScanFraud = true;
              this.removeIframe();
            } else if(response.payload.id_scan_result === "EXISTING_IDENTIFICATION"){
              this.userScanVerifySuccess = false;
              this.existingId = true;
              this.removeIframe();
            } else {
              //if no match found call the getIdNowUrl which shows appropriate message/action needed
              this.getIdNowUrl();
            }
  
          }
        },
        (error: any) => {
          console.log('getIdNowResultWeb: error');
          console.log(error);
          this.userScanVerifySuccess = false;
          this.idScanFailed = true;
          this.removeIframe()
        });
    }
  
    public getIdNowResultCapacitor = () => {
      this.authenticationService.getIDNowResult().subscribe(
        (response: any) => {
          if (response && !!response.result) {
    
            console.log('ID Now Result ::', response.payload);
            this.showLoading();
            // in case loader is stuck
            setTimeout(() => {
              if (this.loading) {
                this.loading.dismiss();
              }
            }, 3000);
            if (response.payload.is_verified === "true") {
              this.registrationSuccessful = true;
              this.userScanVerifySuccess = true;
              this.removeIframe();
              this.doMFA();
            } else if (response.payload.id_scan_result === "inprogress") {
              this.idScanInProgress = true;
              console.log('ID Now URL ::', response.payload.id_scan_url);
              if(response.payload.id_scan_url){
                var url = response.payload.id_scan_url;
                var parts = url.match(/([^\/]*)/g);
                var companyId = parts[5];
                var transactionToken = parts[9];
                var apiHost:string = parts[3];
                var showVideoOverviewCheck = true;
                var showErrorSuccessScreen = true;
                var isTestEnv: boolean = apiHost.indexOf( '.test.')>0;
                console.log( 'id-now:: isTestEnvironment: '+isTestEnv);
                window.cordova.plugins.IdNow.isTestEnvironment( isTestEnv) as any
                
                console.log( 'id-now:: setCompanyId: '+companyId);
                window.cordova.plugins.IdNow.setCompanyId( companyId);
                console.log( 'id-now:: startIdNowSdk: '+transactionToken);
                window.cordova.plugins.IdNow.startIdNowSdk( transactionToken,
                  (success) => {
                    console.log( 'id-now:: startIdNowSdk() SUCCESS:', success);
                    if( 'CANCELLED' == success) {
                      this.userScanVerifySuccess = false;
                      this.idScanInProgress = false;
                      this.removeIframe();
                      this.closeModal();
                      
                    }
                    if('FINISHED' == success){
                    this.eventService.publish('event:SDK', "SDKFINISHED");               
                    }
                  }, (error) => {
                    console.log( 'id-now:: startIdNowSdk() ERROR:', error);
                    this.userScanVerifySuccess = false;
                    this.idScanFailed = true;
                    this.removeIframe();
                  }
                );
              }
            } else if (response.payload.id_scan_result === "pending") {
              this.userScanVerifySuccess = false;
              this.idScanInProgress = false;
              this.removeIframe();
            } else if (response.payload.id_scan_result === "timeout") {
              this.idScanInProgress = false;
              this.removeIframe();
            } else if (response.payload.id_scan_result === "fail") {
              this.userScanVerifySuccess = false;
              this.idScanFailed = true;
              this.removeIframe()
            } else if (response.payload.id_scan_result === "FRAUD_SUSPICION_PENDING") {
              this.userScanVerifySuccess = false;
              this.idScanFraud = true;
              this.removeIframe();
            } else if(response.payload.id_scan_result === "EXISTING_IDENTIFICATION"){
              this.userScanVerifySuccess = false;
              this.existingId = true;
              this.removeIframe();
            } else {
              //if no match found call the getIdNowUrl which shows appropriate message/action needed
              this.getIdNowUrl();
            }
  
          }
        },
        (error: any) => {
          console.log('getIdNowResultCordova: error');
          console.log(error);
          this.userScanVerifySuccess = false;
          this.idScanFailed = true;
          this.removeIframe()
        });
    }
  
  
    IDNowCallBack(data){
      console.log('--IDScanCallback Notification--', data);
      this.message?.dismiss();
      switch (data) {
        case 'INPROGRESS':
          this.idScanInProgress = true;
          break;
        case 'PENDING':
          this.userScanVerifySuccess = false;
          this.idScanInProgress = false;
          this.removeIframe();
          break;
        case 'FAIL':
          this.userScanVerifySuccess = false;
          this.idScanFailed = true;
          this.removeIframe();
          break;
        case 'PASS':
          this.registrationSuccessful = true;
          this.userScanVerifySuccess = true;
          this.removeIframe();
          this.doMFA();
          break;
        case 'RE_KYC_ANNUAL_RECONFIRMATION':
          this.registrationSuccessful = true;
          this.userScanVerifySuccess = true;
          this.removeIframe();
          this.eventService.publish("event:lobby:show");
          setTimeout(() => {
            this.navigator.toCasino(true);
          }, 600);
          break;
        default:
          this.userScanVerifySuccess = false;
          break;
      }
    }
  
    removeIframe() {
        var iframe = document.getElementById("expect-id");
        if(iframe){
          iframe.parentNode.removeChild(iframe);
        }
  
    }
  
    closeModal = () => {
      //Navigator.navigateTo("LogoutPage", { forceModal: true }, {reason:'QUALIFICATION_ID_SCAN_UNFINISHED'});
      console.log('userScanVerifySuccess', this.userScanVerifySuccess);
      if (this.userScanVerifySuccess === null) {
        this.eventService.publish("event:lobby:show");
        this.logoutService.onLogout({reason:'QUALIFICATION_ID_SCAN_UNFINISHED'});
      } else if (this.userScanVerifySuccess) {
        // Success, move user to lobby
        setTimeout(() => {
          this.registrationSuccessful = true;
          this.eventService.publish("event:lobby:show");
          console.log("idscan event:lobby:show");
          this.doMFA();
        }, 1000);
      } else {
        // Failure
        this.eventService.publish("event:lobby:show");
        this.logoutService.onLogout({reason:'QUALIFICATION_ID_SCAN_FAIL'});
      }
    }
  
    doMFA = () => {
      
        const customer_id = this.authenticationService.customer.customerId;
        //this.eventService.publish('event:signupcomplete', { customer_id: customer_id });
        const isSMS_OR_EMAIL = this.configService.getConfig().FEATURE_MFA_TYPE ?? 'SMS';
        const mfa_statuses = this.configService.getConfig().FEATURE_MFA_STATUSES ?? 'ACTIVE, REAL_LOCKED, SELF_EXCLUDED_COOL_OFF, FUNDS_HELD';
        
        return this.userSessionService.refreshCustomer().subscribe((customer: CustomerModel) => {
          if (this.userSessionService.getLoginResponseForMFA() && mfa_statuses.toUpperCase().includes(customer.status.toUpperCase())) {
            this.userSessionService.setMFAStatus(eMfaStatuses.required);
            if (isSMS_OR_EMAIL == 'SMS') {
              this.navigator.navigateTo("SmsLoginComponent", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
            } else {
              this.navigator.navigateTo("CodeLoginPage", { forceModal: true }, { customerId: customer.customerId, callback: this.activateCustomer })
            }
          } else {
            this.activateCustomer();
          }
        });
     
     
    }

    activateCustomer = () => {
      this.navigator.navigateTo("SignupResultComponent", { forceModal: true });
    }

    async showLoading() {
      this.loading = await this.loadingController.create({
        message: 'Please wait loading...',
        duration: 3000
      });
    
      this.loading.present();
    }

  goToFeautureCustomerSupportURL(code, title){
		return this.appLinksService.openMatchedExternalLinksPopover(code, title)
	}

}
